import { IStore } from '../index'

export const getVisitReportvalue = (state: IStore) => state.visitReportReducer
